export interface PickupRequestDashboardActionTypes {
  type: PickupRequestDashboardActions;
  payload?: any;
}

export enum PickupRequestDashboardActions {
  // CREATE_PICKUP_REQUEST_DASHBOARD = "CREATE_PICKUP_REQUEST_DASHBOARD",
  GET_PICKUP_REQUEST_DASHBOARD_LIST = "GET_PICKUP_REQUEST_DASHBOARD_LIST",
  SET_PICKUP_REQUEST_DASHBOARD_LIST = "SET_PICKUP_REQUEST_DASHBOARD_LIST",
  SET_PICKUP_REQUEST_DASHBOARD_PAGE_COUNT = "SET_PICKUP_REQUEST_DASHBOARD_PAGE_COUNT",
  SET_PICKUP_STATUS = "SET_PICKUP_STATUS"
}
